import { ThemeProvider as WebThemeProvider } from 'styled-components';
import { DefaultTheme } from 'styled-components/dist/types';

import { ThemeProvider } from './ThemeProvider';
import GlobalStyles from 'styles/globalStyles/globalStyles';
import App from './App';

interface ThemedAppProps {
  theme: DefaultTheme;
}

const ThemedApp = ({ theme }: ThemedAppProps) => {
  //Add theme to workflows components
  window.flowable.toqioTheme = theme;
  return (
    <ThemeProvider theme={theme}>
      <WebThemeProvider theme={theme}>
        <GlobalStyles theme={theme} />
        <App />
      </WebThemeProvider>
    </ThemeProvider>
  );
};

export { ThemedApp };
